<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      :title="title == 'add' ? '新增施工方案' : '编辑施工方案'"
      :close="close"
      :submitData="submitData"
      :submit="submit"
      id="constructionSimulationProgramme"
      class="newModelPosition hierarchy2"
    >
    </MapModal>
    <PhotoGraphic
      v-if="ifPhotoGraphic"
      v-model="flightData"
      :modelPreview="modelPreview"
    ></PhotoGraphic>
  </div>
</template>
<script>
const PhotoGraphic = () => import("@/components/common/photoGraphic/index.vue");
const MapModal = () => import("@/components/common/mapModal/Index");
import {
  addBimConstructSimGrouping,
  editBimConstructSimGrouping,
} from "@/api/api";
export default {
  name: "constructionSimulationProgramme",
  components: { MapModal, PhotoGraphic },
  props: ["title", "sceneId", "programmeData", "getConstructionSimulationList"],
  data() {
    return {
      ifPhotoGraphic: false,
      flightData: [],
      modalNode: {
        constructionSimulationProgramme: {
          show: true, // 默认展示
          loading: false, // 加载loading
          width: "320px", // 宽度配置 默认450px
          height: `auto`, // 配置模态框中心高度
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "form",
            formData: {
              cameraView: {
                type: "button",
                buttonTitle: "选择视角",
                icon: "el-icon-camera",
                title: "初始视角",
                disabled: false,
                click: this.selectView,
              },
              name: {
                type: "input",
                title: "方案名称",
                placeholder: "请输入方案名称",
              },

              totalTime: {
                type: "daterange",
                title: "总时间",
                // disabledDate: ["2023-5-11", "2023-6-11"],
              },
              // speed: {
              //   type: "radio",
              //   title: "模拟速度",
              //   disabled: false,
              //   selectCreate: true,
              //   options: [
              //     {
              //       name: "快",
              //       id: 1,
              //     },
              //     {
              //       name: "中",
              //       id: 2,
              //     },
              //     {
              //       name: "慢",
              //       id: 3,
              //     },
              //   ],
              // },
            },
            rules: {
              cameraView: [
                {
                  required: true,
                  message: "请选择",
                  trigger: "blur",
                },
              ],
              // model: [
              //   {
              //     required: true,
              //     message: "请选择模型",
              //     trigger: "blur",
              //   },
              // ],
              name: [
                {
                  required: true,
                  message: "请填写名称",
                  trigger: "blur",
                },
              ],
              totalTime: [
                {
                  required: true,
                  message: "请选择时间",
                  trigger: "blur",
                },
              ],
            },
          },
        },
      },
      submitData: {
        cameraView: null,
        name: null,
        // model: null,
        totalTime: null,
        speed: 1,
      },
    };
  },
  computed: {},
  watch: {},
  filters: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  methods: {
    addCategory() {},
    close() {
      this.$emit("close");
      this.submitData = {
        cameraView: null,
        name: null,
        totalTime: null,
        speed: 1,
      };
    },
    modelPreview() {
      this.modalNode.constructionSimulationProgramme.head.fold.state = true;
      this.$parent.modalNode.constructionSimulation.head.fold.state = true;
    },
    selectView() {
      this.ifPhotoGraphic = true;
      this.modalNode.constructionSimulationProgramme.head.fold.state = false;
      this.$parent.modalNode.constructionSimulation.head.fold.state = false;
    },
    cutModelChange() {},
    submit() {
      if (this.title == "add") {
        addBimConstructSimGrouping({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          sceneId: this.sceneId,
          name: this.submitData.name,
          viewGraphic: JSON.stringify(this.submitData.cameraView),
          startTime: this.submitData.totalTime[0],
          endTime: this.submitData.totalTime[1],
          simSpeed: this.submitData.speed,
        })
          .then((res) => {
            let { code } = res.data;
            if (code == 200 || code == 204) {
              this.$notify({
                title: "添加成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              this.getConstructionSimulationList();
            } else {
              this.$notify({
                title: "添加失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          })
          .catch((error) => {
            this.$notify({
              title: "添加失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          });
      } else {
        editBimConstructSimGrouping({
          projectId: window.sessionStorage.getItem("nowProjectId"),
          sceneId: this.sceneId,
          id: this.submitData.id,
          name: this.submitData.name,
          viewGraphic: this.submitData.cameraView,
          startTime: this.submitData.totalTime[0],
          endTime: this.submitData.totalTime[1],
          simSpeed: this.submitData.speed,
        })
          .then((res) => {
            let { code } = res.data;
            if (code == 200 || code == 204) {
              this.$notify({
                title: "编辑成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
              this.getConstructionSimulationList();
            } else {
              this.$notify({
                title: "编辑失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
            }
          })
          .catch((error) => {
            this.$notify({
              title: "编辑失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          });
      }
    },
    deleteEmptyChildren(data) {
      if (data && data.length > 0) {
        data.forEach((item) => {
          if (item.children?.length == 0 && item.id != "-1") {
            delete item.children;
          } else {
            this.deleteEmptyChildren(item.children);
          }
        });
      }
      return data;
    },
    init() {
      console.log("初始化");
      this.submitData = this.programmeData;
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    flightData(newData) {
      this.submitData.cameraView = newData[0];
    },
  },
  destroyed() {
    this.submitData = {
      cameraView: null,
      name: null,
      model: null,
      totalTime: null,
      speed: 1,
    };
  },
};
</script>
<style lang="scss" scoped></style>
